export const PASSWORD_UPDATE_LOADING = 'PASSWORD_UPDATE_LOADING';
export const PASSWORD_UPDATE_SUCCESS = 'PASSWORD_UPDATE_SUCCESS';
export const PASSWORD_UPDATE_ERROR = 'PASSWORD_UPDATE_ERROR';
export const PASSWORD_UPDATE_RESET = 'PASSWORD_UPDATE_RESET';

const initialState = {
    success: null,
    loading: false,
    error: null,
}

const reducer = (state = initialState, action) => {
    switch (action.type) {
        case PASSWORD_UPDATE_LOADING:
            return {
                success: null,
                loading: true,
                error: null,
            };
        case PASSWORD_UPDATE_SUCCESS:
            return {
                success: true,
                loading: false,
                error: null,
            };
        case PASSWORD_UPDATE_ERROR:
            return {
                success: false,
                loading: false,
                error: action.payload,
            };
        case PASSWORD_UPDATE_RESET:
            return initialState;
        default:
            return state;
    }
}

const storeName = "passwordUpdate";

const storeMapping = {[storeName]: reducer};

export const passwordUpdateSelector = (state) => state[storeName];

export default storeMapping;
